module.exports = __webpack_public_path__ + "static/logo-ttm-89e0e9577b5cad9ecb291f0c8891ef28.svg";